export const getBotName = (bot: {personalityID: string; instanceID: string}) =>
    bot.personalityID + "-" + bot.instanceID;
